import React from "react";
import PropTypes from "prop-types";

var ModalHeaderCustom = function ModalHeaderCustom(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "et--modal-header"
  }, children);
};

ModalHeaderCustom.propTypes = {
  children: PropTypes.any.isRequired
};
export default ModalHeaderCustom;